export const humanizeDate = (dateTime) => {
  const date = new Date(dateTime);
  return new Intl.DateTimeFormat('en-GB').format(date);
}

export const humanizeTime = (dateTime) => {
  const date = new Date(dateTime);
  const hours = date.getHours();
  const minutes = date.getMinutes();
  return `${hours}:${minutes < 10 ? `0${minutes}` : minutes }`;
}

export const durationOfTravel = (start, end) => {
  return ((new Date(end) - new Date(start)) / 1000) / 60;
}
